'use strict';

import Backbone from 'backbone';
import config from '../../js/config';
import * as BomService from '../../services/BomService';
import * as CsrfService from '../../services/CsrfService';
import CartUserService from '../../services/CartUserService';
import templateBomModalCreate from './templates/BomModalCreate.hbs';

export default class BomModalCreate extends Backbone.View {
  get events() {
    return {
      'keydown .BomModal-create .BomModal-input': 'handleEnterName',
      'click .BomModal-create-button': 'handleBomCreate',
      'keyup .BomModal-quantity .BomModal-input': 'handleChangeQuantity'
    }
  }

  initializeElements() {
    this.$bomNameInput = this.$('.BomModal-create .BomModal-input');
    this.$bomNameError = this.$('.BomModal-create-error');
    this.$bomCreateButton = this.$('.BomModal-create-button');
    this.$bomQuantity = this.$('.BomModal-quantity .BomModal-input');
  }

  render() {
    this.$el.html(templateBomModalCreate({
      loggedIn: CartUserService.isUserLoggedIn(),
      bomList: this.collection.toJSON(),
      partId: this.partId,
      quantity: this.quantity
    }, { data: { analytics: config.analytics } }));

    this.initializeElements();
  }

  /**
   * Remove error when user enters a name
   *
   * @param {Event} e
   */
  handleEnterName(e) {
    // Submit the create form
    if (e.key === 'Enter' || e.keyCode === 13) {
      this.$bomCreateButton.trigger('click');
      return;
    }

    // Ignore the shift and tab key
    if (e.key === 'Shift' || e.keyCode === 16 || e.key === 'Tab' || e.keyCode === 9) {
      return;
    }

    // Remove the error once user starts typing
    if (!this.$bomNameInput.val().length) {
      this.$bomNameError.addClass(config.classes.uHide);
    }
  }

  /**
   * Attempt to create a new BOM
   */
  handleBomCreate() {
    let name = this.$bomNameInput.val();

    // Validate a name was entered
    if (!name.length) {
      this.$bomNameError.removeClass(config.classes.uHide);
      this.$bomNameInput.focus();
      return false;
    }

    this.createBom(name);
  }

  /**
   * Add loading status
   */
  setLoading() {
    let width = this.$bomCreateButton.outerWidth();
    this.$bomCreateButton.css({ width: width });
    this.$bomCreateButton.prop('disabled', true);
    this.$el.addClass(config.classes.loadingClass);
  }

  /**
   * Remove loading status
   */
  setLoaded() {
    this.$bomCreateButton.css({ width: false });

    if (CartUserService.isUserLoggedIn()) {
      this.$bomCreateButton.prop('disabled', false);
    }

    this.$el.removeClass(config.classes.loadingClass);
  }

  /**
   * Create a new bom
   *
   * @param {string} bomName
   */
  createBom(bomName) {
    // Need to defer the method due to disable attribute blocking analytics
    setTimeout(() => this.setLoading(), 1);

    CsrfService.getToken().then(csrfToken => {
      BomService.createBom(bomName, csrfToken).then(bomData => {
        this.setLoaded();
        this.collection.add(bomData);
        this.$bomNameInput.val(this.$bomNameInput.data('default'));
        this.$bomCreateButton.focus();
      });
    });
  }

  handleChangeQuantity() {
    this.trigger('change:quantity', this.$bomQuantity.val());
  }
}



// WEBPACK FOOTER //
// ./assets/components/BomModal/BomModalCreate.js